/* **************************************************** Finishing Shedule Door Size */
export interface FSDoorSize {
    id: number;
    category: string;
    size_name: string;
    created_by: number | null;
}

export const mapFSDoorSize = (data: any): FSDoorSize => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSDoorSize = {
        id: data.id,
        category: data.category,
        size_name: data.size_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSDoorSizes = (data: any[]): FSDoorSize[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSDoorSize);
};
